import React, { useEffect, useRef, useState, useCallback } from "react"; // Added useCallback
import './Groupyouhavejoin.css';
import './yourgroups3.css';
import { imageUrl, makeGetRequest, makePostRequest, makePostRequestForAll } from "../../services/api";
import { URLS } from "../../constants";
import FourDotsLoader from "../Common.WebAppMate/FourDoted";
import Joingroup2 from "./joingrouppopup2";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ResourceCard from "../ShareInspiration.WebAppMate/ResourceCard";
import { decodeToken, getTime, getTimeDifference, toastifyMessage, handleFileDownload } from "../../utilities/CustomFunctions";
import GroupChat from "./GroupChat";
import RightSideGroup from "./RightSideGroup";
import Paper from "@material-ui/core/Paper";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import unpin from "../../assets/Images/unpin.png"
import Multiselect from "multiselect-react-dropdown";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { getFilterOptions } from "../../store/reducers/searchReducer";
import { getFileIcon } from "../Chat.WebAppMate/Service";
import CryptoJS from 'crypto-js';
import Announce from "./Announce";
import ResourcePopup from "../Common.WebAppMate/ResourcePopup";
import Head from "../Layout.WebAppMate/head/Head";
import { Learningpillar } from "../Common.WebAppMate/Learningpillar";
import Searchpage from "../Search.WebAppMate/Searchpage";
import { setIsOnResource} from "../../store/reducers/searchReducer";
 
const secretKey = process.env.REACT_APP_DATA_ENCRYPT_DESCRYP_KEY;

const ITEMS_PER_PAGE = 10; // Define items per page for secondary fetches

const GroupYouhaveJoin = () => {
  const dispatch = useDispatch();
  const searchStore = useSelector((state) => state.search);
  const { filterOptions } = searchStore;
  const { learning_pillars } = filterOptions;
  const navigate = useNavigate(); // Use lowercase navigate consistently
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const getimage = imageUrl;
  const user = decodeToken().userAuth;
  const UserImage = user.photo;
  const param = useParams();
    const { id, groupname } = useParams();
 

  // --- State Declarations ---
  const [groupId, setGroupId] = useState(null);
  const [spin, setSpin] = useState(false); // Main loading spinner (initial/reset)
  const [downSpin, setDownSpin] = useState(false); // Spinner for infinite scroll loading
  const [joinGroupPopUp, setJoinGroupPopUp] = useState(false);
  const [resourceData, setResourceData] = useState([]);
  const [page, setPage] = useState(1);
  const [groupDetail, setGroupDetail] = useState(null); // Initialize as null
  const menuRef = useRef(null);
  const [hasMore, setHasMore] = useState(true); // Renamed from status - indicates if more data might exist
  const [ismember, setIsMember] = useState(false);
  const [joinTime, setJoinTime] = useState("");
  const [value, setValue] = useState("group_feed"); // Current active tab/view
  const [resourceList, setResourceList] = useState([]);
  // Filters
  const [resource, setResource] = useState("");
  const [learningPillarSelected, setLearningPillarSelected] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  // ---
  const [announceChatCount, setAnnounceChatCount] = useState(1); // Tracks remaining secondary items (0 = no more)
  const [adminId, setAdminId] = useState([]); // Initialize as array
  const [announcement, setAnnouncement] = useState(false);
  const [messageId, setMessageId] = useState("");
  const [, setByNotification] = useState(false); // Keep if needed, otherwise remove
  const [resourcePopUp, setResourcePopUp] = useState(false);
  const [requestStatus, setRequestStatus] = useState("");
  const [groupStatus, setGroupStatus] = useState("");
  const [actionStatus, setActionStatus] = useState({ action_group: "", action_id: "" });
   const isOnResource = useSelector(state => state.search.isOnResource);
   const chat = queryParams.get("passKey");
 const handleToggleforResource = () => {
    dispatch(setIsOnResource(!isOnResource));
  };
 
 
  // --- Decode Group ID ---
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll top when ID changes
    if (param.id) {
      try {
        let decodedId;
        if (!isNaN(param.id)) {
          decodedId = param.id;
        } else {
          const encryptedString = atob(param.id); // Decode Base64
          const decryptedBytes = CryptoJS.AES.decrypt(encryptedString, secretKey);
          decodedId = decryptedBytes.toString(CryptoJS.enc.Utf8);
        }
        setGroupId(decodedId);
        // Reset state when group ID changes
        setPage(1);
        setResourceData([]);
        setHasMore(true);
        setValue(chat === "chat" ? "group_chat" : "group_feed"); // Default to feed view
        // Reset filters too? Depends on desired UX
        setKeyword("");
        setResource("");
        setLearningPillarSelected([]);
        setSelectedStartDate(null);
        setSelectedEndDate(null);

      } catch (error) {
        console.error("Error decoding group ID:", error);
        toastifyMessage("Invalid group link.", "error");
        navigate('/groups'); // Redirect on error
      }
    }
  }, [param.id, navigate]); // Added navigate to dependencies

  // --- Initial Setup (Fetch Filter Options, Resources) ---
  useEffect(() => {
    if (groupId) { // Only run if groupId is successfully set
        dispatch(getFilterOptions());
        getAllResources();
    }
      // Add CSS class
      document.body.classList.add("groupJoin");
      // Cleanup function
      return () => {
        document.body.classList.remove("groupJoin");
      };
  }, [groupId, dispatch]); // Depend on groupId and dispatch

  // --- Get Static Resource List ---
  const getAllResources = () => {
    makeGetRequest(URLS.getAllResources)
      .then((res) => {
        if (res.code === 200) {
          setResourceList(res.data || []); // Ensure it's an array
        }
      })
      .catch((error) => {
        console.error("Error fetching resource list:", error);
        toastifyMessage("Could not load resource types.", "error");
      });
  };

  // --- Centralized Data Fetching Function ---
  const fetchGroupData = useCallback(async (pageNum, isNewSearch = false) => {
    if (!groupId) return; // Don't fetch if groupId is not set

    // Set loading states
    if (pageNum === 1) {
      setSpin(true);
      setDownSpin(false); // Ensure downSpin is off for initial load
    } else {
      // Only set downSpin if we expect more data
      if(hasMore) setDownSpin(true);
      else return; // Don't fetch if hasMore is false
    }

    if (isNewSearch) {
      setResourceData([]); // Clear data for new search/tab
      setAnnounceChatCount(1); // Reset secondary item count for new search
    }

    const payload = {
      group_id: groupId,
      group_type: value, // Use the current tab value
      keyword: keyword,
      shared_by_id: [],
      learning_pillar_id: learningPillarSelected,
      page_number: pageNum,
      resource_type: resource,
      start_date: (selectedStartDate && moment(selectedStartDate).format("YYYY-MM-DD")) || "",
      end_date: (selectedEndDate && moment(selectedEndDate).format("YYYY-MM-DD")) || "",
    };

    try {
      const res = await makePostRequest(URLS.getShareResourceByGroup, null, payload, null);

      // --- Process primary response ---
      if (res.code !== 200) {
          throw new Error(res.message || "Failed to fetch group data");
      }

      const data = res.data || {};
      const groupDetails = data.groupDetails || {};
      const primaryResponse = data.response || [];
      const saveInfo = data.save || [];
      const remainingPrimary = data.remaining_count; // Assuming 1 means more, 0 means no more

      // Update group details only if page is 1 or groupDetail is not set yet
       if (pageNum === 1 || !groupDetail) {
        setIsMember(data.is_member || false);
        setGroupStatus(groupDetails.status || "");
        setAdminId(groupDetails.group_admin_users?.map(u => u.user_id) || []);
        setRequestStatus(data.invite_group || "");
        setActionStatus({
          action_group: data.action_group || "", action_id: data.action_id || ""
        });
        setGroupDetail(groupDetails);
        setJoinTime(getTimeDifference(groupDetails.created_at));
      }

      // Map save status to primary data
      const processedPrimaryData = primaryResponse.map(item => ({
        ...item,
        save: saveInfo.some(s => s.resource_id === item.resource_id) ? "yes" : "no"
      }));

      let combinedData = [...processedPrimaryData];
      let finalHasMore = remainingPrimary === 1; // Assume 1 means more for primary
      let currentAnnounceCount = announceChatCount; // Use local var

      // --- Conditionally fetch secondary data (Announcements/Shared Groups) ---
      // Fetch only if the primary fetch indicated more OR if secondary items might still exist
      if(keyword=="")
      {
      if (
        (value === "group_announcement" || (value === "group_feed" && resource === "")) && // Fetch only for feed/announce (and feed only if no resource filter)
        (finalHasMore || currentAnnounceCount !== 0) // Fetch if primary has more OR secondary might have more
      ) {
        const isAnnouncement = value === "group_announcement";
        const secondaryUrl = isAnnouncement ? URLS.getSharedChat : URLS.shareInvitationofGroupFeed;
        const secondaryPayload = {
          item_per_page: ITEMS_PER_PAGE,
          page_number: pageNum, // Use the same pageNum for simplicity here
          group_id: groupId
        };

        try {
          // Show spinner while fetching secondary data too
          if(pageNum === 1) setSpin(true); else setDownSpin(true);

          const secondaryRes = await makePostRequest(secondaryUrl, null, secondaryPayload, null);
          if (secondaryRes.code === 200) {
              const secondaryResponseData = (isAnnouncement ? secondaryRes.data?.response : secondaryRes.data?.groupShare) || [];
              const remainingSecondary = secondaryRes.data?.remaining_count; // Assume 0 means no more

              combinedData = [...combinedData, ...secondaryResponseData];
              setAnnounceChatCount(remainingSecondary); // Update secondary count

              // Overall 'hasMore' is true if EITHER primary OR secondary has more
              finalHasMore = finalHasMore || (remainingSecondary !== 0);
          } else {
              console.warn(`Failed to fetch secondary ${value} data:`, secondaryRes.message);
              // Don't throw error, primary data might still be useful
          }

        } catch (secondaryError) {
          console.error(`Error fetching secondary ${value} data:`, secondaryError);
          toastifyMessage(`Could not load all ${value} items.`, "warning");
        }
      } }
      else if (value !== "group_announcement" && value !== "group_feed"){
          // If not feed/announce, hasMore depends only on primary remaining_count
          setAnnounceChatCount(0); // No secondary items for other tabs
      }

      // --- Sort and Update State ---
      combinedData.sort((a, b) => new Date(b.shared_date_time) - new Date(a.shared_date_time));

      setResourceData(prevData => isNewSearch ? combinedData : [...prevData, ...combinedData]);
      setHasMore(finalHasMore); // Update based on combined results

    } catch (error) {
      console.error("Error fetching group data:", error);
      toastifyMessage(error.message || "Failed to load group feed.", "error");
      setHasMore(false); // Stop pagination on error
    } finally {
      setSpin(false);
      setDownSpin(false);
    }
  }, [
      groupId, value, keyword, learningPillarSelected, resource, selectedStartDate,
      selectedEndDate, announceChatCount, hasMore, groupDetail // Include groupDetail to potentially avoid refetching details
    ] // Dependencies for useCallback
  );

  // --- Effect to Fetch Data on Initial Load or groupId Change ---
  useEffect(() => {
    if (groupId) {
      setPage(1); // Ensure page is 1 for initial load of a group
      fetchGroupData(1, true); // Fetch page 1, treat as new search
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupId]); // Triggered only when groupId changes


  // --- Effect to Fetch Data on Tab Change ---
  useEffect(() => {
    if (groupId && value !== 'group_chat') { // Only fetch for non-chat tabs here
      // Reset filters relevant to feed/events/resources when tab changes
      setPage(1);
      setKeyword("");
      setResource("");
      setLearningPillarSelected([]);
      setSelectedStartDate(null);
      setSelectedEndDate(null);
      setHasMore(true); // Assume more data on tab change initially
      fetchGroupData(1, true); // Fetch page 1, treat as new search
    }
     else if (value === 'group_chat') {
         // Optionally clear resource data if switching TO chat
         // setResourceData([]);
         setSpin(false); // Ensure spinners are off for chat view
         setDownSpin(false);
     }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, groupId]); // Triggered when tab value or groupId changes


  // --- Effect for Infinite Scroll Pagination ---
   useEffect(() => {
    // Fetch when page changes (for pages > 1)
     if (groupId && page > 1) {
        // Do not trigger fetch if hasMore is already false
        if (hasMore) {
          fetchGroupData(page, false); // Fetch current page number, append data
        } else {
          // console.log("Infinite scroll attempted, but no more data (hasMore is false).");
        }
     }
     // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [page]); // Triggered only when page changes (and groupId is set)


  // --- Scroll Event Handler ---
  const handleScroll = useCallback(() => {
    const threshold = 150; // Pixels from bottom to trigger loading
    // Check if scrolled near the bottom, not currently loading, and expects more data
    if (
      window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - threshold &&
      !downSpin && // Check the downSpin state specifically for scroll loading
      hasMore &&   // Check if more data is expected
      groupId      // Ensure groupId is set
    ) {
      // console.log("Scroll threshold reached. Incrementing page.");
      // Increment page state to trigger the useEffect hook for pagination
      setPage((prevPage) => prevPage + 1);
    }
  }, [downSpin, hasMore, groupId]); // Dependencies for the scroll handler

  // --- Effect to Add/Remove Scroll Listener ---
  useEffect(() => {
    if (value !== 'group_chat') { // Only add listener if not in chat view
      window.addEventListener("scroll", handleScroll);
      // console.log("Scroll listener added.");
    } else {
      window.removeEventListener("scroll", handleScroll); // Remove if switching TO chat
      // console.log("Scroll listener removed (chat view active).");
    }
    // Cleanup function
    return () => {
      window.removeEventListener("scroll", handleScroll);
      // console.log("Scroll listener removed on cleanup.");
    };
  }, [handleScroll, value]); // Re-attach listener if handler or value changes

  // --- Accept/Reject Invitation ---
  const acceptInvitation = (id, status) => {
    const payload = { action_id: id, status: status };
    setSpin(true); // Show spinner
    makePostRequestForAll(URLS.UpdateAccpedReject, payload)
      .then((res) => {
        toastifyMessage(res.message, "success");
        setPage(1); // Reset page
        fetchGroupData(1, true); // Refetch data from page 1
        // Mark notification (optional, depending on your flow)
        const notificationId = queryParams.get('go');
        if (notificationId) {
          makePostRequest(URLS.markSingleNotification, null, { notification_id: notificationId })
            .catch(err => console.error("Failed to mark notification:", err));
        }
      })
      .catch((error) => {
        console.error("Error updating invitation:", error);
        toastifyMessage("Failed to update invitation status.", "error");
        setSpin(false); // Hide spinner on error
      });
  };

  // --- Filter Handlers ---
  const handlePillars = (selectedList) => {
    setLearningPillarSelected(selectedList?.map(val => val.id) || []);
  };

  const handleResourceFilter = (selectedList) => {
    const selectedId = selectedList?.length > 0 ? selectedList[selectedList.length - 1].id : "";
    setResource(selectedId);
  };

  const handleKeywordChange = (e) => {
    setKeyword(e.target.value);
  };

  const handleKeywordSearch = (e) => {
      if (e.key === 'Enter') {
          handleSearchClick();
      }
  }

  // --- Search Button Click ---
  const handleSearchClick = () => {
      if(value !== 'group_chat') { // Only search on non-chat tabs
        setPage(1);
        setHasMore(true); // Assume search might find new results
        fetchGroupData(1, true); // Trigger fetch with current filters, reset page
      }
  };

  // --- Utility Function ---
  function truncate(str, length = 11) {
    return str?.length > length ? str.slice(0, length) + '...' : str;
  }

  // --- Render Logic ---

  // Show main spinner if loading initially or resetting
  if (spin && page === 1 && !groupDetail) {
     return <div className="sharepopupOuter backgroundOpacity1"><FourDotsLoader /></div>;
  }

  // Render disabled group message
  if (groupStatus === "disable") {
    return (
      <div className="col-lg-10 col-md-12 col-sm-12 padding-row">
          <Head title="Group Disabled" content="This group has been disabled." />
          <div className="your-main-group">
              <div className="your-grp row">
                  <div className="col-lg-8 col-12">
                      <div className="chat-group-innere">
                          <div className="the-secret">
                              <h1 className="text-capitalize">Group Disabled By Super Admin</h1>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    );
  }

  // Render main component content
  return (
    <>
      <Head title={groupDetail?.group_name || "Group Detail"}
        content={groupDetail?.about_group || "Build and support your community..."}></Head>
      {/* Spinners */}
      {spin && <div className="sharepopupOuter backgroundOpacity1"><FourDotsLoader /></div>}

      {/* Popups */}
      {resourcePopUp && groupDetail && (
        <ResourcePopup
          data={() => setResourcePopUp(false)}
          userImg={getimage + UserImage}
          fullName={user?.firstName + " " + user?.lastName}
          id={groupDetail.id}
          label={groupDetail.group_name}
          type={adminId.includes(user.id) ? "Admin" : "Member"}
          value={groupDetail.id} // Assuming value is the group ID here
          countryName={groupDetail.country_name}
        />
      )}
       {joinGroupPopUp && groupDetail && (
          <Joingroup2
            datar={() => setJoinGroupPopUp(false)}
            value={groupId}
            forwardedref={menuRef} // This ref might not be necessary here
            getSuggestion={() => {}} // Placeholder
            funcall={() => { setPage(1); fetchGroupData(1, true); }} // Refetch on successful join
            groupName={groupDetail.group_name}
            permission={groupDetail.group_join_permission}
          />
       )}
        {announcement && (
          <Announce
            messageId={messageId}
            handleClose={() => setAnnouncement(false)}
            announcement={announcement}
            getShreResource={() => { setPage(1); fetchGroupData(1, true); }} // Refetch after pin/unpin
            type="no" // Assuming 'no' means unpin action
          />
        )}

      {/* Main Content Area */}
      {groupDetail && ( // Render only if groupDetail is loaded
        <div className="col-lg-10 col-md-12 col-sm-12 padding-row">
          <div className="your-main-group">
            {/* Group Header Info */}
            <div className="your-grp row">
              <div className="col-lg-8 col-12">
                <div className="chat-group-innere">
                  <div className="the-secret">
                    <h1 className="text-capitalize">{groupDetail.group_name}</h1>
                    <p className="">Created {joinTime} </p>
                  </div>
                  <div className="text-curriculum11">
                    {Array.isArray(groupDetail.tbl_group_learning_pillars) &&
                      groupDetail.tbl_group_learning_pillars.map((item, i) =>
                        Learningpillar(item?.tbl_learning_pillar_master?.name, i)
                      )}
                    <h2 className="createaddmembers ">{groupDetail.no_of_user} Members</h2>
                  </div>
                  <div className="descTextDatainfo square scrollbar-dusty-grass square thin">
                    <p className="pdesctext" dangerouslySetInnerHTML={{ __html: groupDetail.about_group }}></p>
                  </div>
                   {groupDetail.url && groupDetail.url !== "" &&
                    <div className="descTextDatainfo square scrollbar-dusty-grass square thin">
                      <div className="chat-group">
                        <div>
                          <a href={groupDetail.url} target="_blank" rel="noopener noreferrer">
                            <button className="mt-3">Group Website</button>
                          </a>
                        </div>
                      </div>
                    </div>
                    }
                </div>
              </div>
              <div className="col-lg-4 col-12 side-img">
                <div className="slider-page float-end-custome mb-2">
                  <img src={groupDetail.image || '/path/to/default/group/image.png'} alt={groupDetail.group_name || 'group'} loading="lazy" onError={(e) => e.target.src='/path/to/default/group/image.png'}/>
                </div>
                {/* Action Buttons */}
                <div className="chat-group mb-2">
                   {ismember && (
                      <button onClick={() => setResourcePopUp(true)} className="mx-2">
                        Create Resource
                      </button>
                    )}
                   {ismember ? (
                     <> {/* Member View: Toggle Chat/Resources */}
                       {value === "group_chat" ? (
                         <button className="mb-4" onClick={() => setValue("group_feed")}>
                           Resources
                         </button>
                       ) : (
                         <button onClick={() => setValue("group_chat")}>
                           Group Chat
                         </button>
                       )}
                       <div className="d-flex justify-content-center">
                          <button onClick={() => navigate(`/group-members/${groupId}`)} className="mx-4 mt-2">Manage Group</button>
                       </div>
                     </>
                    ) : (
                      <> {/* Non-Member View: Join/Pending/Accept/Reject */}
                        {requestStatus === "Join" ||ismember==false ? (
                          <button className="joins-group" onClick={() => setJoinGroupPopUp(true)}>
                            Join Group
                          </button>
                        ) : actionStatus?.action_group === "action" ? (
                          <>
                            <button className="join-group" onClick={() => acceptInvitation(actionStatus.action_id, "accepted")}>
                              Accept
                            </button>
                            <button className="join-group" onClick={() => acceptInvitation(actionStatus.action_id, "rejected")}>
                              Reject
                            </button>
                          </>
                        ) : (
                          <button className="joins-group" disabled>
                            Request Pending
                          </button>
                        )}
                      </>
                    )}
                </div>
              </div>
            </div>

             {/* Main Content Area (Tabs, Filters, Feed/Chat) */}
            <div className={`blur-part ${ismember ? "" : "non-member-view"}`}> {/* Added class for non-members */}
                 {/* Tabs Navigation */}
                 <div className="grouptablayout">
                    {/* Desktop Tabs */}
                     <div className="d-md-block d-none">
                         <Paper square>
                         <Tabs value={value} textColor="primary" indicatorColor="primary"
                             onChange={(event, newValue) => {
                                setValue(newValue);
                                // Data fetching is handled by useEffect[value]
                             }} >
                             <Tab label="Group Feed" value="group_feed" />
                             <Tab label="Events" value="group_event" />
                             <Tab label={<span><span className="group-name">{truncate(groupDetail.group_name)}</span> Bulletin Board</span>} value="group_announcement" />
                             <Tab label={<span><span className="group-name">{truncate(groupDetail.group_name)}</span> Resources</span>} value="group_admin" />
                             {/* {ismember && <Tab label="Group Chat" value="group_chat" />} */}
                              {ismember && <Tab label="Group Chat" value="group_chat" />}
                             <Tab className="icons-remove-hidden" label={<div><span><span className="group-name">{truncate(groupDetail?.group_name)} <br/></span>Member Resources</span><div className="facustomeI">i<div className="tootlippillerinfo">
                    Resources Saved and Reviewed by Group Members.
                    </div></div></div>} value="group_searchResource"  onClick={handleToggleforResource} />
 
                         </Tabs>
                         </Paper>
                     </div>
                     {/* Mobile Select */}
                     <div className="row">
                         <div className="col-md-12 d-md-none d-sm-block">
                         <div className="form-group">
                             <select className="form-control" id="exampleFormControlSelect1"
                                onChange={(e) => setValue(e.target.value)}
                                value={value}>
                                 <option value="group_feed">Group Feed</option>
                                 <option value="group_event">Events</option>
                                 <option value="group_announcement">{truncate(groupDetail.group_name)} Bulletin Board</option>
                                 <option value="group_admin">{truncate(groupDetail.group_name)} Resources</option>
                                 {ismember && <option value="group_chat">Group Chat</option>}
                             </select>
                         </div>
                         </div>
                     </div>
                 </div>

                 {/* Search/Filter Area - Conditionally Rendered */}
                   {(value === "group_searchResource") ? "" :<>
                  {value !== 'group_chat' && (
                     <div className="partsearch">
                         <div className="searchpart-div">
                         {/* Hide filters for announcement tab */}
                          {value !== "group_announcement" && (
                            <div className="group-search-bar" id={value === "group_event" ? "" : "groupfeedsearchbox"}>
                               {/* Resource Type Filter (Not for events) */}
                                {/* {value !== "group_event" && (
                                <div className="input-search-div learninghiddenscroll">
                                    <label>Select Resource</label>
                                    <Multiselect
                                        options={resourceList}
                                        onSelect={handleResourceFilter}
                                        onRemove={handleResourceFilter}
                                        // onKeyPressFn={() => { }} // Not needed usually
                                        showCheckbox
                                        showArrow
                                        // onSearch={function noRefCheck() { }} // Not needed usually
                                        placeholder="Resource Type"
                                        displayValue="name"
                                        selectedValues={resource ? resourceList.filter(item => item.id === resource) : []} // Simplified selection
                                        singleSelect={true} // Set to single select if only one is allowed
                                        avoidHighlightFirstOption={true}
                                        closeOnSelect={true}
                                    />
                                </div>
                                )} */}
                                {/* Keyword Filter */}
                                <div className="input-search-div keyword-search-out">
                                <label>Keywords</label>
                                <input
                                    type="text"
                                    className="input-btn-icon-icon"
                            placeholder={
                                      value === "group_feed"
                                        ? "Enter Keywords to Search Group Feed "
                                        : value === "group_event"
                                        ? "Enter Keywords to Search Events"
                                        : value === "group_admin"
                                        ? "Enter Keywords to Search Resources"
                                        : "Keyword Search"
                                    }                                    onChange={handleKeywordChange}
                                    value={keyword}
                                    name="keywords"
                                    onKeyPress={handleKeywordSearch} // Use specific handler
                                />
                                </div>
                                {/* Learning Pillar Filter */}
                                {/* <div className="input-search-div learninghiddenscroll">
                                <label>Learning Pillar</label>
                                <Multiselect
                                    options={learning_pillars || []} // Ensure it's an array
                                    onSelect={handlePillars}
                                    onRemove={handlePillars}
                                    showCheckbox
                                    displayValue="name"
                                    placeholder="Learning Pillar"
                                    selectedValues={learning_pillars?.filter((pillar) => // Handle potential undefined pillars
                                    learningPillarSelected.includes(pillar.id)
                                    ) || []}
                                />
                                </div> */}
                                {/* Date Filters (Only for events) */}
                                {/* {value === "group_event" && (
                                <>
                                    <div className="input-search-div">
                                    <label> Start Date</label>
                                    <DatePicker
                                        className="border-0 w-100 searchDate"
                                        selected={selectedStartDate}
                                        onChange={(date) => setSelectedStartDate(date)}
                                        placeholderText="Start date"
                                        dateFormat="MM-dd-yyyy"
                                        isClearable
                                    />
                                    </div>
                                    <div className="input-search-div">
                                    <label> End Date</label>
                                    <DatePicker
                                        className="border-0 w-100 searchDate"
                                        selected={selectedEndDate}
                                        onChange={(date) => setSelectedEndDate(date)}
                                        placeholderText="End date"
                                        dateFormat="MM-dd-yyyy"
                                        minDate={selectedStartDate} // Prevent end date before start date
                                        isClearable
                                    />
                                    </div>
                                </>
                                )} */}
                                {/* Search Button */}
                                <button className="search-btn" onClick={handleSearchClick}>
                                 <i className="fa fa-search"></i>
                                </button>
                            </div>
                         )}
                         </div>
                     </div>
                  )}
                 </>}
                 {/* Feed or Chat Content */}
                 {(value === "group_searchResource" && isOnResource === true)
  && <>
<Searchpage grpname={"grpname"} groupname ={groupname} groupid={id} />
  </>}
  {(value === "group_searchResource") ? "" :<>
 
                <div className="row chat-main">
                   {/* Left Column (Feed/Chat) */}
                    <div className="col-lg-8">
                        {value === 'group_chat' ? (
                             <GroupChat groupDetail={groupDetail} adminId={adminId} />
                        ) : (
                         <>
                             {/* Resource Feed */}
                              {resourceData.length > 0 ? resourceData.map((val, index) => (
                                 <React.Fragment key={val.resource_id || val.group_id || val.massageUniqueId || `item-${index}`}>
                                     {val.resource_id ? (
                                         <ResourceCard value={val} userImg={getimage + UserImage}
                                             groupId={value === "group_announcement" ? groupId : ""}
                                             funcall={() => { setPage(1); fetchGroupData(1, true); }} // Refresh on action
                                             status="group" // Indicates it's within a group context
                                             admin={adminId.includes(user.id) ? "Admin" : "Member"}
                                             group_id={groupDetail.id}
                                         />
                                     ) : val.group_id ? (
                                          // Shared Group Card (Simplified structure)
                                         <div className="inspiration-div">
                                            {/* ... Shared Group rendering ... */}
                                              <div className="inspiration-inner-div">
                                                  <div className="d-flex gap-3">
                                                      <img className="img-fluid" src={val?.group_shared_by_user?.photo || '/path/to/default/user.png'} alt="shared by user" onError={(e) => e.target.src='/path/to/default/user.png'}/>
                                                      <h3 className="text_capital"><strong className="friendInspirationcapital">{val?.group_shared_by_user?.name}</strong> shared the group : <br />
                                                      </h3>
                                                      {/* <label>{getTimeDifference(val.shared_date_time)}</label> */}
                                                  </div>
                                              </div>
                                               <div className="SummerCamp">
                                                <div className="d-flex">
                                                    {val?.group_detail?.image &&
                                                    <div className="img-Facilitiess" style={{ cursor: "pointer" }} onClick={() => navigate(`/groupjoin/${btoa(CryptoJS.AES.encrypt(val.group_id.toString(), secretKey).toString())}`)}>
                                                        <img src={val.group_detail.image} alt={val?.group_detail?.group_name || 'Group'} className="curriculum-image2" onError={(e) => e.target.src='/path/to/default/group/image.png'}/>
                                                    </div>
                                                    }
                                                    <div className="summer-text">
                                                    <h3 className="share-title" style={{cursor:'pointer'}} onClick={() => navigate(`/groupjoin/${btoa(CryptoJS.AES.encrypt(val.group_id.toString(), secretKey).toString())}`)} >{val?.group_detail?.group_name}</h3>
                                                    <div className=" description-sharee" dangerouslySetInnerHTML={{ __html: val?.group_detail?.about_group }}>
                                                    </div>
                                                    <div className="text-curriculum11 mt-2">
                                                        {Array.isArray(val?.group_detail?.tbl_group_learning_pillars) &&
                                                        val.group_detail.tbl_group_learning_pillars.map((item, i) => Learningpillar(item?.tbl_learning_pillar_master?.name, i))}
                                                    </div>
                                                    {/* Conditionally show Join Group if not already a member of THAT group */}
                                                     {/* Add logic here based on val.isJoin or similar property if available for the shared group */}
                                                    </div>
                                                </div>
                                                </div>

                                         </div>
                                     ) : val.massageUniqueId ? (
                                         // Announcement Card
                                         <div className="inspiration-div rounded">
                                             <div className="inspiration-inner-div">
                                                 <div className="SummerCamp-2 ">
                                                     <div className="d-flex justify-content-between"> {/* Use flex utilities */}
                                                         <div className="d-flex flex-grow-1"> {/* Allow text content to grow */}
                                                             <div className="img-fuild anncounce me-3"> {/* Add margin */}
                                                                 <img src={val.send_by_user_photo || '/path/to/default/user.png'} className="" alt="user" loading="lazy" onError={(e) => e.target.src='/path/to/default/user.png'} />
                                                             </div>
                                                             <div className="summer-text pb-2">
                                                                 <h3>{val?.send_by_name} <span className="ms-2 text-muted small">{getTime(val?.shared_date_time, "announce")}</span></h3>
                                                                 {/* File/Image Display */}
                                                                  {val.chat_doc && (
                                                                    <div>
                                                                      {['png', 'jpg', 'jpeg', 'gif', 'PNG', 'JPG', 'JPEG', 'GIF'].includes(val.fileExtension) ? (
                                                                        <img src={val.chat_doc} alt="announcement attachment" loading="lazy" className="announce-img my-1" style={{cursor:'pointer'}} onClick={() => handleFileDownload(val.chat_doc, `MatchEd_doc_${val.fileExtension}`)} />
                                                                      ) : (
                                                                        <div style={{cursor:'pointer'}} onClick={() => handleFileDownload(val.chat_doc, `MatchEd_doc_${val.fileExtension}`)}>
                                                                          {val.fileExtension ? getFileIcon(val.fileExtension) : <i className="fa fa-file"></i>}
                                                                           <span className='ms-2'>{`Download ${val.fileExtension || 'file'}`}</span>
                                                                        </div>
                                                                      )}
                                                                    </div>
                                                                  )}
                                                                 {/* Message Text */}
                                                                 <div className="mt-1">{val?.message}</div>
                                                             </div>
                                                         </div>
                                                          {/* Unpin Button (Only for admins?) - Add conditional logic */}
                                                          {adminId.includes(user.id) && value === "group_announcement" && (
                                                            <div className="unpin align-self-start" onClick={() => { setAnnouncement(true); setMessageId(val.massageUniqueId); }}>
                                                                <img src={unpin} alt="unpin" loading="lazy" />
                                                            </div>
                                                          )}
                                                     </div>
                                                 </div>
                                             </div>
                                         </div>
                                     ): null }
                                 </React.Fragment>
                             )) : (
                                 !spin && !downSpin && <h1 className="text-center mt-5">No Data Found</h1> // Show only if not loading
                             )}

                             {/* Loading indicator for infinite scroll */}
                              {downSpin && (
                                <div className="share-spiner text-center my-4">
                                    <FourDotsLoader />
                                </div>
                               )}
                              {/* End of data message */}
                              {!downSpin && !hasMore && resourceData.length > 0 && (
                                  <p className='text-center text-muted my-4'>You've reached the end.</p>
                              )}

                         </>
                        )}
                    </div>

                   {/* Right Column (Members/Admins) */}
                    <div className="col-lg-4">
                        <RightSideGroup id={groupId} isMember={ismember} />
                    </div>
                </div>
                </>}
                 {/* Blur overlay for non-members */}
                 {!ismember && <div className="blur-overlay"></div>}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GroupYouhaveJoin;
